import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  alpha,
  useTheme,
} from '@mui/material';

// Fallback renderer used when no audit-type-specific renderer is registered.
// Shows the cma.audit record's core columns; jobResults is rendered as a
// pre-formatted JSON snippet for inspection. Most audits will eventually
// have a purpose-built renderer; this is the "it still works" baseline.
function DefaultTable({ records }) {
  const theme = useTheme();

  if (!records || records.length === 0) {
    return (
      <Paper sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
        <Typography variant="body1" color="text.secondary">
          No records match the current filters.
        </Typography>
      </Paper>
    );
  }

  const answerColor = (answer) => {
    const a = (answer || '').toString().toLowerCase();
    if (a === 'pass')    return 'success';
    if (a === 'fail')    return 'error';
    if (a === 'warning') return 'warning';
    if (a === 'error')   return 'error';
    return 'default';
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 2,
        border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Account</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Answer</TableCell>
            <TableCell>Comments</TableCell>
            <TableCell>Updated</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map((r) => (
            <TableRow key={r.id} hover>
              <TableCell sx={{ fontWeight: 600 }}>{r.account}</TableCell>
              <TableCell>{r.title}</TableCell>
              <TableCell>
                <Chip label={r.answer || '—'} size="small" color={answerColor(r.answer)} />
              </TableCell>
              <TableCell sx={{ maxWidth: 320 }}>
                <Typography variant="body2" sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}>
                  {r.comments || ''}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="caption" color="text.secondary">
                  {r.lastUpdated || ''}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default DefaultTable;
